import {Component, EventEmitter, Input, Output} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {Observable} from 'rxjs';
import {isNil} from 'lodash-es';
import {MIHttpClientService} from '../mi-http-client.service';
import {ClientSideErrorsService} from '../client-side-errors.service';

@Component({
    selector: 'edit-modal-layout',
    templateUrl: './edit-modal-layout.component.html',
    styleUrls: ['./edit-modal-layout.component.scss'],
    standalone: false
})
export class EditModalLayoutComponent {
  @Input() form: FormGroup;
  @Input() pageTitle: Observable<string>;
  @Input() canSave: boolean;
  @Input() showSave = true;
  @Input() ignoreFormValidity: boolean;
  @Input() layoutClass: string = '';
  @Input() showRequiredText = true;
  @Input() saveId = 'save';
  @Input() cancelId = 'cancel';
  @Input() resetSaveStatus = false;
  @Output() save: EventEmitter<any> = new EventEmitter<any>();
  @Output() onCancel: EventEmitter<void> = new EventEmitter<void>();

  _saveEmitted = false;

  constructor(private miClient: MIHttpClientService,
              private clientSideErrorService: ClientSideErrorsService,
  ) {
    let errorHandler = error => {
      if(!isNil(error)) {
        // handle server side validation api errors
        // allow the user to do changes and save again
        this._saveEmitted = false;
      }
    };

    this.miClient.apiError$.subscribe(errorHandler);
    this.clientSideErrorService.clientError$.subscribe(errorHandler);
  }


  get saveEnabled(): boolean {
    // if for some reasons we don't want save regardless of form status
    if(this.canSave === false) {
      return false;
    }

    // prevent double click actions
    if(this._saveEmitted === true && this.resetSaveStatus === false) {
      return false;
    }

    return this.ignoreFormValidity || this.form?.valid;
  }

  onSaveClicked($event: MouseEvent) {
    this._saveEmitted = true;
    this.save.emit($event);
  }
}
